import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

const outline = defineStyle({
    border: '1px solid black',
    opacity: 0.5,
    fontSize: 'sm',
    color: 'white',
    bg: 'gray.500',
    px: 1.5,
    py: 0.5,
    borderRadius: 3,
});

export const kbdTheme = defineStyleConfig({
    variants: { outline },
    defaultProps: {
        variant: 'outline',
    },
});

export default kbdTheme;
